<!-- Header.vue -->
<template>
  <nav class="w-full px-5 bg-[#11111b] sticky top-0 z-50">
    <div class="max-w-7xl mx-auto px-2 sm:px-4 md:px-6 lg:px-8">
      <div class="flex items-center justify-between h-14 sm:h-16 md:h-18">
        <!-- Logo -->
        <div class="flex-shrink-0">
          <router-link to="/" class="text-xl sm:text-2xl md:text-3xl font-bold italic">BORENN</router-link>
        </div>

        <!-- Desktop Menu -->
        <div class="hidden md:flex items-center space-x-4 lg:space-x-8">
          <router-link to="/" class="nav-link hover:text-[#00b4d8] text-sm lg:text-base" exact>Home</router-link>
          <router-link to="/about" class="nav-link hover:text-[#00b4d8] text-sm lg:text-base">About</router-link>

          <router-link to="/project-posts" class="nav-link hover:text-[#00b4d8] text-sm lg:text-base"
            data-section="projects">Projects</router-link>
          <router-link to="/services-clients"
            class="nav-link hover:text-[#00b4d8] text-sm lg:text-base">Services</router-link>
          <!-- <router-link to="/blogs-posts" class="nav-link hover:text-[#00b4d8] text-sm lg:text-base"
            data-section="projects">Blogs</router-link> -->
        </div>

        <!-- Mobile Menu Toggle -->
        <div class="md:hidden">
          <button @click="toggleMenu"
            class="inline-flex items-center justify-center p-2 rounded-md text-white hover:text-gray-300 hover:bg-gray-800 focus:outline-none"
            aria-controls="mobile-menu" :aria-expanded="isMenuOpen">
            <span class="sr-only">Open main menu</span>
            <MenuIcon v-if="!isMenuOpen" class="w-5 h-5 sm:w-6 sm:h-6" />
            <XIcon v-else class="w-5 h-5 sm:w-6 sm:h-6" />
          </button>
        </div>
      </div>
    </div>

    <!-- Mobile Menu -->
    <transition enter-active-class="transition ease-out duration-200"
      enter-from-class="transform opacity-0 -translate-y-2" enter-to-class="transform opacity-100 translate-y-0"
      leave-active-class="transition ease-in duration-150" leave-from-class="transform opacity-100 translate-y-0"
      leave-to-class="transform opacity-0 -translate-y-2">
      <div v-if="isMenuOpen" class="md:hidden" id="mobile-menu">
        <div class="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-[#11111b]">
          <router-link to="/"
            class="nav-link px-3 py-2 rounded-md text-sm font-medium hover:text-[#00b4d8] hover:bg-gray-800 block"
            exact>Home</router-link>
          <router-link to="/about"
            class="nav-link px-3 py-2 rounded-md text-sm font-medium hover:text-[#00b4d8] hover:bg-gray-800 block">About</router-link>

          <router-link to="/project-posts"
            class="nav-link px-3 py-2 rounded-md text-sm font-medium hover:text-[#00b4d8] hover:bg-gray-800 block"
            data-section="projects">Projects</router-link>
          <router-link to="/services-clients"
            class="nav-link px-3 py-2 rounded-md text-sm font-medium hover:text-[#00b4d8] hover:bg-gray-800 block">Services</router-link>
          <!-- <router-link to="/blogs-posts"
            class="nav-link px-3 py-2 rounded-md text-sm font-medium hover:text-[#00b4d8] hover:bg-gray-800 block"
            data-section="projects">Blogs</router-link> -->


        </div>
      </div>
    </transition>
  </nav>
</template>

<script setup>
import { ref, watch } from 'vue';
import { MenuIcon, XIcon } from 'lucide-vue-next';
import { useRouter, useRoute } from 'vue-router';

const isMenuOpen = ref(false);
const router = useRouter();
const route = useRoute();

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};

// Handle section scrolling for links with data-section
const scrollToSection = (sectionId) => {
  if (route.path !== '/') {
    router.push({ path: '/', hash: `#${sectionId}` }).then(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    });
  } else {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
  isMenuOpen.value = false;
};

// Watch route changes to close mobile menu
watch(() => route.path, () => {
  isMenuOpen.value = false;
});
</script>

<style scoped>
.nav-link {
  color: #ffffff;
  text-decoration: none;
  transition: color 0.3s ease;
}

.nav-link:hover {
  color: #00b4d8;
}

.nav-link.router-link-exact-active {
  color: #00b4d8;
  font-weight: 600;
}

@media (max-width: 640px) {
  .nav-link.router-link-exact-active {
    color: #00b4d8;
    background-color: #1e1e2f;
    font-weight: 600;
  }
}
</style>